import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import forward from "../../Assets/next-arrow.png";
import "./Navbar.css";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const navbarRef = useRef(null);
  const lastScrollY = useRef(0);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setScrolled(currentScrollY > 40);

      if (
        currentScrollY > lastScrollY.current &&
        currentScrollY > 150 &&
        !menuOpen
      ) {
        setHidden(true);
      } else {
        setHidden(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [menuOpen]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const handleMouseMove = (event) => {
    if (!navbarRef.current) return;

    const rect = navbarRef.current.getBoundingClientRect();

    navbarRef.current.style.setProperty(
      "--mouse-x",
      `${event.clientX - rect.left}px`
    );

    navbarRef.current.style.setProperty(
      "--mouse-y",
      `${event.clientY - rect.top}px`
    );
  };

  const toggleMenu = () => {
    setMenuOpen((previous) => !previous);
    setHidden(false);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <header
        className={`navbar-wrapper ${
          scrolled ? "navbar-scrolled" : ""
        } ${hidden ? "navbar-hidden" : ""} ${
          menuOpen ? "navbar-menu-open" : ""
        }`}
      >
        <nav
          ref={navbarRef}
          className="navbar"
          onMouseMove={handleMouseMove}
        >
          <Link to="/" className="navbar-logo" onClick={closeMenu}>
            <div className="etoe-brand">
              <div className="etoe-symbol">
                <span className="etoe-letter etoe-e">
                  <i className="e-top" />
                  <i className="e-middle" />
                  <i className="e-bottom" />
                </span>

                <span className="etoe-letter etoe-t">
                  <i className="t-top" />
                  <i className="t-stem" />
                </span>

                <span className="etoe-letter etoe-o" />

                <span className="etoe-letter etoe-e">
                  <i className="e-top" />
                  <i className="e-middle" />
                  <i className="e-bottom" />
                </span>
              </div>

              <span className="etoe-productions">
                PRODUCTIONS
              </span>
            </div>
          </Link>

          <div className="navbar-links">
            <Link
              to="/"
              className={`nav-link ${
                isActive("/") ? "nav-link-active" : ""
              }`}
            >
              Home
            </Link>

            <Link
              to="/about"
              className={`nav-link ${
                isActive("/about") ? "nav-link-active" : ""
              }`}
            >
              About
            </Link>

            <Link
              to="/work"
              className={`nav-link ${
                isActive("/work") ? "nav-link-active" : ""
              }`}
            >
              Work
            </Link>

            <Link
              to="/services"
              className={`nav-link ${
                isActive("/services") ? "nav-link-active" : ""
              }`}
            >
              Services
            </Link>
          </div>

          <Link to="/contact" className="navbar-cta">
            <span>Start Project</span>
            <img
              src={forward}
              alt="arrow"
              className="cta-arrow"
            />
          </Link>

          <button
            className={`navbar-menu-button ${
              menuOpen ? "navbar-menu-button-active" : ""
            }`}
            type="button"
            onClick={toggleMenu}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
          >
            <span />
            <span />
          </button>
        </nav>
      </header>

      <div
        className={`mobile-menu ${
          menuOpen ? "mobile-menu-open" : ""
        }`}
      >
        <div className="mobile-menu-glow" />

        <nav className="mobile-menu-navigation">
          <Link
            to="/"
            onClick={closeMenu}
            className={`mobile-menu-link ${
              isActive("/") ? "mobile-menu-link-active" : ""
            }`}
          >
            <span>01</span>
            <strong>Home</strong>
          </Link>

          <Link
            to="/about"
            onClick={closeMenu}
            className={`mobile-menu-link ${
              isActive("/about")
                ? "mobile-menu-link-active"
                : ""
            }`}
          >
            <span>02</span>
            <strong>About</strong>
          </Link>

          <Link
            to="/work"
            onClick={closeMenu}
            className={`mobile-menu-link ${
              isActive("/work")
                ? "mobile-menu-link-active"
                : ""
            }`}
          >
            <span>03</span>
            <strong>Work</strong>
          </Link>

          <Link
            to="/services"
            onClick={closeMenu}
            className={`mobile-menu-link ${
              isActive("/services")
                ? "mobile-menu-link-active"
                : ""
            }`}
          >
            <span>04</span>
            <strong>Services</strong>
          </Link>
        </nav>

        <Link
          to="/contact"
          className="mobile-menu-cta"
          onClick={closeMenu}
        >
          <span>Start a Project</span>
          <img src={forward} alt="" />
        </Link>

       
      </div>
    </>
  );
}

export default Navbar;